import { render, staticRenderFns } from "./playerManager.vue?vue&type=template&id=e0e85a70"
import script from "./playerManager.vue?vue&type=script&lang=js"
export * from "./playerManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports